(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('jira', ["$timeout", "sideMenuManager", "brandInfo", function ($timeout, sideMenuManager, brandInfo) {
        var jiraWidget = {
            init: function () {
                jiraWidget.hide();
            },
            show: function () {
                if (angular.element('#jsd-widget').length) {
                    angular.element('#jsd-widget').show();
                    angular.element('#jsd-widget').css('width', '70px');
                    angular.element('#jsd-widget').css('height', '80px');
                }
            },
            hide: function () {
                if (angular.element('#jsd-widget').length) {
                    angular.element('#jsd-widget').hide();
                }
            },
            open: function () {
                // check jira widget loaded
                if (angular.element('#jsd-widget').length) {
                    $timeout(function () {
                        // trigger clicking on jira question mark
                        angular.element('#jsd-widget').contents().find('#help-button').trigger('click');
                        angular.element('#jsd-widget').addClass('open');
                        // modal position center
                        angular.element('#jsd-widget').contents().find('.form-container').attr('style', 'margin: 80px auto 0 auto !important');
                        var currentUser = sideMenuManager.currentUser();
                        if (currentUser && currentUser.email) {
                            var $jiraEmailInput = angular.element('#jsd-widget').contents().find('#email');
                            $jiraEmailInput.attr('placeholder', 'Press space key to autofill');
                            $jiraEmailInput.on('keypress', function (e) {
                                if (e.keyCode === 32) {
                                    $jiraEmailInput.val(currentUser.email);
                                }
                            });
                        }
                        var portalName = brandInfo.customerSubdomain();
                        if (portalName) {
                            angular.element('#jsd-widget').contents().find('input[title="Portal Name"]').val(portalName);
                        }
                        angular.element('#jsd-widget').show();
                        jiraWidget.onCloseModal();
                    });
                }
            },
            onCloseModal: function () {
                if (angular.element('#jsd-widget').length) {
                    var confirmInterval;
                    // listen clicking on close button
                    angular.element('#jsd-widget').contents().off('click');
                    angular.element('#jsd-widget').contents().on('click', function (e) {
                        if (e.target.className) {
                            var targetClasses = e.target.className.split(' ');
                            if (_(targetClasses).findIndex(function (cls) {
                                    return cls === 'close-icon';
                                }) !== -1) {
                                angular.element('#jsd-widget').removeClass('open');
                                angular.element('#jsd-widget').hide();
                            }
                        }
                        if (e.target.id == 'submit-button') {
                            if (!confirmInterval) {
                                confirmInterval = setInterval(function () {
                                    var $confirmElement = angular.element('#jsd-widget').contents().find('#confirmation-container');
                                    if ($confirmElement && $confirmElement.length) {
                                        $confirmElement.attr('style', 'position: fixed; top: calc(50% - 100px); left: calc(50% - 200px);');
                                        clearInterval(confirmInterval);
                                    }
                                }, 10);
                            }
                        }
                    });
                } else {
                    console.log('Jira widget not loaded.');
                }
            }
        };
        return jiraWidget;
    }]);
}());